"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import Slider from "react-slick";
import { useMemo } from "react";
import WalletReviewsSkeleton from "./_skeletons/WalletReviewsSkeleton";

export const WalletReviewsSection = () => {
  const { trans } = useUtility();
  const { elements, loading } = useSection("wallet_reviews");

  const settings = useMemo(
    () => ({
      autoplay: true, // <--- Enable autoplay
      autoplaySpeed: 2000, // <--- Optional: set speed (ms)
      loop: true,
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      arrows: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
          },
        },
      ],
    }),
    [],
  );

  if (loading) return <WalletReviewsSkeleton />;

  return (
    <section
      className="review-section section-bg pb-60"
      style={{ height: "280px", overflow: "hidden" }}
    >
      <div className="container wallet-container">
        <div className="row">
          <div className="col-sm-1"></div>
          <div className="col-sm-11">
            <div
              className="review-slider-wrapper tw-stretch-element-inside-column"
              style={{
                marginLeft: "0px",
                marginRight: "-308px",
              }}
            >
              <Slider {...settings} className="review-slider">
                {elements?.map((item, index) => (
                  <div className="review-item" key={index}>
                    <div className="review-item__top">
                      <h6 className="review-item__name">{trans(item.name)}</h6>
                      <ul className="rating-list">
                        {Array.from({
                          length: parseInt(item.rating || "0"),
                        }).map((_, i) => (
                          <li className="rating-list__item" key={i}>
                            <span className="rating-list__item-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 15 14"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_3829_17941)">
                                  <path
                                    d="M3.61442 13.4003C3.27938 13.5721 2.89921 13.2709 2.96691 12.8864L3.68733 8.7809L0.629459 5.86798C0.343896 5.59544 0.49232 5.09722 0.875096 5.0434L5.12643 4.43929L7.02209 0.68357C7.19308 0.34506 7.65571 0.34506 7.8267 0.68357L9.72236 4.43929L13.9737 5.0434C14.3565 5.09722 14.5049 5.59544 14.2185 5.86798L11.1615 8.7809L11.8819 12.8864C11.9496 13.2709 11.5694 13.5721 11.2344 13.4003L7.42309 11.4421L3.61442 13.4003Z"
                                    fill="currentColor"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3829_17941">
                                    <rect
                                      width="13.8876"
                                      height="13.8876"
                                      fill="white"
                                      transform="translate(0.476562)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <p className="review-item__desc">{trans(item.review)}</p>
                    <span className="review-item__date">
                      {trans(item.date)}
                    </span>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
